import axios from './axios';

export default new class {
    async getContratos(cpfCnpj) {
        try {
            const fingerprint = localStorage.getItem('fingerprint')
            const fingerprintComponents = localStorage.getItem('fingerprintComponents')
            const fingerprintConfidence = localStorage.getItem('fingerprintConfidence')

            const response = await axios.post('/list-contracts', {
                cpfCnpj,
                fingerprint,
                fingerprintComponents,
                fingerprintConfidence
            });

            if (!response || !response.data || !response.data.status || response.data.status != 'success' || !response.data.contratosPendentes || !response.data.token)
                throw new Error('Resposta inválida')

            // Como esta é a primeira requisição realizada à API, é setado o token de autenticação recebido
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('contratosPendentes', JSON.stringify(response.data.contratosPendentes))

            axios.refreshToken()

            return response.data.contratosPendentes
        }
        catch (error) {
            return false;
        }
    }

    async getPdf(idContrato) {
        try {
            const response = await axios.post('/get-pdf', { idContrato });

            if (!response || !response.data || !response.data.status || response.data.status != 'success' || !response.data.base64Contrato)
                throw new Error('Resposta inválida')

            return response.data.base64Contrato
        }
        catch (error) {
            return false;
        }
    }

    async concluirAtivacao(idContrato) {
        try {
            const fingerprint = localStorage.getItem('fingerprint')
            const fingerprintComponents = localStorage.getItem('fingerprintComponents')
            const fingerprintConfidence = localStorage.getItem('fingerprintConfidence')

            const response = await axios.post('/execute-activation', {
                idContrato,
                fingerprint,
                fingerprintComponents,
                fingerprintConfidence
            });

            if (!response || !response.data || !response.data.status || response.data.status != 'success')
                throw new Error('Resposta inválida')

            return true
        }
        catch (error) {
            return false;
        }
    }
}